import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Container from "./components/Container";
import PincodeSearch from "./components/PincodeSearch";
import { CATEGORIES } from "./categories";
import styles from "./pages/Results.module.css";

export default function Search() {
  const history = useHistory();

  const onSearch = ({ service_category, pincode }) => {
    if (!pincode) {
      toast.error("Please enter a pincode.");
      return;
    }
    localStorage.setItem("listservice", service_category);
    localStorage.setItem("listpincode", pincode);
    history.push("/list");
  };

  return (
    <div>
      <Nav />
      <main className={styles.page}>
        <Container>
          <div className={styles.head}>
            <h1 className={styles.title}>Find a pro near you</h1>
            <p className={styles.muted}>Pick a service and enter your pincode to see available providers.</p>
          </div>
          <div className={styles.searchWrap}>
            <PincodeSearch categories={CATEGORIES} onSearch={onSearch} />
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
